"use client";

import React, { useEffect } from "react";
import {
  setInviteLinkCookie,
  setReferralCookie,
} from "./setReferralCookieAction";
import { useRouter } from "next-nprogress-bar";
import { GondolaLoading } from "@/components/ui/gondolaLoading";
import { useSession } from "next-auth/react";
import { useMainLayout } from "@/app/context/mainLayoutProvider";
import { linkInviteIfExists } from "@/lib/userServerActions";

type Props = {
  referralCode?: string;
  inviteToken?: string;
};

const InvitePage: React.FC<Props> = ({ referralCode, inviteToken }) => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const { isWebView, isWebViewLoaded } = useMainLayout();

  useEffect(() => {
    (async () => {
      if (!isWebViewLoaded) return;
      if (status === "loading") return;
      if (inviteToken) {
        await setInviteLinkCookie(inviteToken);
        if (session?.accessToken) {
          try {
            await linkInviteIfExists(session.accessToken);
          } catch {
            // Keep the invite cookie for a later retry, but do not strand the user on the loading page.
          }
          return router.push("/");
        }
        return router.push(isWebView ? "/" : "/onboarding?invite=1");
      }
      if (!referralCode) {
        return router.push("/");
      }
      if (isWebView && !session) {
        await setReferralCookie(referralCode);
        return router.push("/");
      } else if (session) {
        return router.push("/");
      } else {
        await setReferralCookie(referralCode);
        const destination =
          referralCode !== "early_access_1254"
            ? "/onboarding?referral=1"
            : "/onboarding";
        return router.push(destination);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWebViewLoaded, session?.accessToken, status]);

  return (
    <div className="relative flex flex-col items-center justify-center gap-2">
      <GondolaLoading containerClassName="h-screen place-content-center" />
    </div>
  );
};

export default InvitePage;
